import React from 'react';
import { supportUrls } from '../../../shared/utils/urls';

const PrivacyPolicy = () => (
  <div className="privacy-policy-container">
    <p>
      By clicking sign up, you agree to the TrulyInbox{' '}
      <a
        href={supportUrls.privacyPolicy}
        target="_blank"
        rel="noreferrer noopener"
      >
        Privacy Policy
      </a>{' '}
      and{' '}
      <a
        href={supportUrls.termsOfServices}
        target="_blank"
        rel="noreferrer noopener"
      >
        Terms of Service.
      </a>
    </p>
  </div>
);

export default PrivacyPolicy;
